import { Injectable } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Subject, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AppNotification } from 'src/app/models/notification';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private baseURL = environment.apiURL;

  // Create an observable stream that AppComponent can listen to
  public modalTrigger$ = new Subject<{
    title: string;
    body: string;
    txnId: any;
    txnType: any;
    createdAt: any;
  }>();

  // NEW: emits a fully-formed notification whenever one arrives in foreground
  public newNotification$ = new Subject<AppNotification>();

  constructor(
    private messaging: Messaging,
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler,
    private toastr: ToastrService,
     private router: Router
) {}

  requestPermission() {
    if (Notification.permission === 'denied') {
      console.warn('Notifications are blocked. Please enable them in browser settings.');

       // Inform the user to enable notifications
      const title = 'Push Notifications Blocked';
      const body = 'Please enable them by clicking on your username on the top right corner!';

      this.toastr.error(body, title, {
        enableHtml: true,
        closeButton: true
      });
      return;
    }

    let apiURL = `${this.baseURL}/v1/save-token`;

    getToken(this.messaging, { vapidKey: 'BEN1z8pgBvfZEPAzlKs0YX0Z6ybNSWVjQ_o-5eAu4zw1gOLBf8ysADeE0z9rupZI5wzxfGRGVYhCs8Gs4dg4_gI' })
      .then((token) => {
        if (token) {
          this.http.post(apiURL, { token, device_type: 'web' })
            .pipe(catchError(this.errorHandler.handleError))
            .subscribe();
        } else {
          console.log('FCM Token Not Generated');
        }
      })
      .catch((err) => {
        console.error('Error getting FCM token:', err);
    });
  }

  listenForMessages() {
    onMessage(this.messaging, (payload) => {
      /**
       *  Show the notification on a toast as well
       * and push it to the notifications dropdown
       */
      const title = payload.notification?.title || 'Notification';
      const body = payload.notification?.body || '';

      // Extract custom variable keys sent over from your Laravel payload array
      const txnId = payload.data?.['txn_id'] || null;
      const txnType = payload.data?.['txn_type'] || null;
      const createdAt = payload.data?.['txn_date'] || null;

      // Push the notification to the notifications dropdown
      const notification: AppNotification = {
        title,
        message: body,
        created_at: new Date(),
        read: false,
        txn_id: txnId,
        txn_type: txnType
      };
      this.newNotification$.next(notification);

      const activeToast = this.toastr.info(body, title, {
        closeButton: true,
        progressBar: true
      });

      // When toast panel is clicked, emit values into the channel pipeline
      activeToast.onTap.subscribe(() => {
        if(txnType=="transfer"){

          const url = this.router.serializeUrl(
            this.router.createUrlTree(['/view-transferred-vehicle', txnId])
          );

          window.open(url, '_blank');
        }else if(txnType=="receive"){

          const url = this.router.serializeUrl(
            this.router.createUrlTree(['/view-received-vehicle', txnId])
          );

          window.open(url, '_blank');
        }else if(txnType=="delivery"){

          const url = this.router.serializeUrl(
            this.router.createUrlTree(['/view-transferred-vehicle', txnId])
          );

          window.open(url, '_blank');
         }else if(txnType=="vessel_eta_update"){

          const url = this.router.serializeUrl(
            this.router.createUrlTree(['/update-bl', txnId])
          );

          window.open(url, '_blank');
        }else if(txnType=="duty"){

          const url = txnId;
          window.open(url ?? undefined, '_blank');
        }else{
          this.modalTrigger$.next({ title, body, txnId, txnType, createdAt });
        }
      });
    });
  }

  // Helper to open the modal directly (useful for background URL redirects)
  public triggerGlobalModal(data: { title: string; body: string; txnId: any; txnType: any; createdAt: Date|null }) {
    this.modalTrigger$.next(data);
  }
}
